import React from 'react';

const Loader = () => (
    <div style={{ justifyContent: 'center', display: 'flex' }}>
        <div className="loading-indicator-container">
            <div className="line"/>
            <div className="subline inc"/>
            <div className="subline dec"/>
        </div>
    </div>
);

export default Loader;
